import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select, Store } from '@ngxs/store';
import { AssetState, CancelSubscription, ProductState } from '@platform-frontend/checkout';
import { MSG_CANCEL_SUBSCRIPTION_SUCCESS, MSG_RESET_DEMO_SUCCESS, Product } from '@platform-frontend/marketplace';
import { CloseWindow, Navigate, ShowSuccessNotification } from '@platform-frontend/util';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'yat-cancel-subscription',
  templateUrl: './cancel-subscription.component.html',
  styleUrls: ['./cancel-subscription.component.scss']
})
export class CancelSubscriptionComponent {
  constructor(private activatedRoute: ActivatedRoute, private store: Store) {}

  @Select(AssetState.endOfPeriod)
  endOfPeriod$: Observable<Date | null>;

  @Select(AssetState.endOfNoticePeriod)
  endOfNoticePeriod$: Observable<Date | null>;

  @Select(AssetState.terminationDate)
  terminationDate$: Observable<Date | null>;

  @Select(AssetState.product)
  product$: Observable<Product | null>;

  @Select(ProductState.isLive)
  isLive$: Observable<boolean>;

  cancelSubscription(): void {
    const isLive = this.store.selectSnapshot(ProductState.isLive);
    this.store
      .dispatch(new CancelSubscription())
      .pipe(
        switchMap(() => this.store.dispatch(new ShowSuccessNotification(isLive ? MSG_CANCEL_SUBSCRIPTION_SUCCESS : MSG_RESET_DEMO_SUCCESS))),
        switchMap(() =>
          isLive
            ? this.store.dispatch(new Navigate(['../cancel-confirmation'], { replaceUrl: true, clearNotifications: false, relativeTo: this.activatedRoute }))
            : this.store.dispatch(new CloseWindow())
        ),
        untilDestroyed(this)
      )
      .subscribe();
  }

  back(clearNotifications?: boolean): Observable<unknown> {
    return this.store.dispatch(new Navigate(['../overview'], { relativeTo: this.activatedRoute, clearNotifications }));
  }
}
